module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_9006.2294d8a9.png";